import dayjs from 'dayjs'

import { OrderStateEnum } from '@/shared/api/intranet'

import type { FullOrder } from '@/entities/shop'

type CancellableOrder = Pick<FullOrder, 'status' | 'can_be_cancelled_until'>

// Заказ ещё в окне отмены (дедлайн отмены не истёк)
const isWithinCancelWindow = (order: CancellableOrder) =>
  Boolean(order.can_be_cancelled_until && dayjs(order.can_be_cancelled_until).isAfter(dayjs()))

// Заказ можно отменить: не отменён и ещё в окне отмены
export const canCancelOrder = (order: CancellableOrder) =>
  order.status !== OrderStateEnum.CANCELLED && isWithinCancelWindow(order)
